// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShareHover_wrapper__3rNGd"};